import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { AsyncScheduler } from 'rxjs/internal/scheduler/AsyncScheduler';
import { VisibaApiHttp } from '../../../Classes/visibaHttp.class';
import { GuiComponentApiModel } from './Models/GuiComponentApiModel';

@Injectable()
export class UnitApiService {
	private readonly baseUri = '/api/Client/v2/units'; // Todo: extend a base api class

	constructor(private readonly httpService: VisibaApiHttp) {
		// Empty
	}

	public getUnitComponents(receptionId: number) {
		const url = `${this.baseUri}/${receptionId}/guicomponents`;

		return this.httpService.getTyped<GuiComponentApiModel[]>(url);
	}
}
